import { render, staticRenderFns } from "./blankdetail.vue?vue&type=template&id=365b6a7b&scoped=true"
import script from "./blankdetail.vue?vue&type=script&lang=js"
export * from "./blankdetail.vue?vue&type=script&lang=js"
import style0 from "./blankdetail.vue?vue&type=style&index=0&id=365b6a7b&prod&lang=stylus&scoped=true"
import style1 from "./blankdetail.vue?vue&type=style&index=1&id=365b6a7b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b6a7b",
  null
  
)

export default component.exports